import { gql } from '@apollo/client'

export const SELF_ASSIGN_PROCESSING = gql`
  mutation selfAssignProcessing($poolSlug: String!, $id: ID) {
    selfAssignProcessing(poolSlug: $poolSlug, id: $id) {
      id
      m2Case {
        id
      }
    }
  }
`
